import { WorkoutLimits } from "../../../Resources/Constants";

const setWorkoutExercises = (workout, exercises) => {
  if (!workout) return;
  if (typeof workout.setProperty === "function") {
    workout.setProperty("exercises", exercises);
    return;
  }
  workout.exercises = exercises;
};

export const getLibraryWorkoutName = (workout, t) => {
  const explicitName =
    typeof workout?.name === "string" ? workout.name.trim() : "";
  if (explicitName) return explicitName;
  const workoutNumber = (workout?.order ?? 0) + 1;
  return t?.("workoutWithNumber-string", { number: workoutNumber }) ?? "Workout";
};

export const persistLibraryWorkoutChange = (coach, workout) => {
  if (!coach || !workout) return;
  workout?.setProperty?.("hasChanged", true);
  coach?.updateCoachTransactionWorkouts?.(String(workout.id).toLowerCase());
  coach?.startOrResetBatchTimer?.();
};

export const deleteLibraryWorkoutExercise = ({ workout, exercise, coach }) => {
  if (!workout || !exercise) return false;
  const current = Array.isArray(workout.exercises) ? workout.exercises : [];
  const idx = current.findIndex((item) => item?.id === exercise?.id);
  if (idx < 0) return false;

  const next = current
    .filter((item) => item?.id !== exercise?.id)
    .sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));

  next.forEach((item, index) => {
    if (!item) return;
    item.order = index;
  });

  setWorkoutExercises(workout, next);
  persistLibraryWorkoutChange(coach, workout);
  return true;
};

export const pasteExercisesIntoLibraryWorkout = ({
  workout,
  coach,
  t,
  showToast,
}) => {
  if (!workout || !coach) return 0;
  const payloads = Array.isArray(coach?.copiedExercises)
    ? coach.copiedExercises
    : [];
  if (payloads.length === 0) return 0;

  const currentExerciseCount = Array.isArray(workout?.exercises)
    ? workout.exercises.length
    : 0;
  if (
    currentExerciseCount + payloads.length >
    WorkoutLimits.MAX_EXERCISES_PER_WORKOUT
  ) {
    showToast?.("maxExercisesPerWorkoutReached-string", {
      type: "warning",
      title: "maxExercisesPerWorkoutReached-string",
      description: "maxExercisesPerWorkoutDescription-string",
      variables: { limit: WorkoutLimits.MAX_EXERCISES_PER_WORKOUT },
    });
    return 0;
  }

  const createdCount =
    workout?.pasteExercisesFromClipboardPayloads?.(payloads) ?? 0;

  if (createdCount > 0) {
    persistLibraryWorkoutChange(coach, workout);
    showToast?.("exercisesPasted-string", {
      type: "info",
      title: "exercisesPasted-string",
      description: "exercisesPastedDescription-string",
      variables: {
        workoutName: getLibraryWorkoutName(workout, t),
      },
    });
  }

  return createdCount;
};

export const createLibraryWorkoutCardAdapter = ({ workout, coach }) => {
  const coachProxy = Object.create(coach ?? {});
  coachProxy.updateCoachTransactionBlocks = () => {
    if (!coach || !workout) return;
    coach.updateCoachTransactionWorkouts?.(String(workout.id).toLowerCase());
  };
  coachProxy.startOrResetBatchTimer = () => {
    coach?.startOrResetBatchTimer?.();
  };

  const adapter = {
    id: `library-workout-${workout?.id ?? "unknown"}`,
    workouts: workout ? [workout] : [],
    protocols: [],
    protocolsAndExercises: [],
    selectedLift: null,
    selectedPriority: null,
    selectedSecondary: false,
    selectedWeek: workout?.week ?? 1,
    exercisesExpanded: true,
    blockViewEditingWorkoutId: null,
    coach: coachProxy,
    client: null,
    getWeekName: () => "",
    setProperty(propertyName, value) {
      this[propertyName] = value;
    },
    setBlockViewEditingWorkoutId(workoutId) {
      this.blockViewEditingWorkoutId = workoutId
        ? String(workoutId).toLowerCase()
        : null;
    },
    clearBlockViewEditingWorkoutId() {
      this.blockViewEditingWorkoutId = null;
    },
    deleteWorkoutExercise(exercise) {
      deleteLibraryWorkoutExercise({ workout, exercise, coach });
    },
  };

  return adapter;
};
